import { ReactNode } from "react";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";

interface FeaturePageLayoutProps {
  children: ReactNode;
}

export function FeaturePageLayout({ children }: FeaturePageLayoutProps) {
  return (
    <div className="min-h-screen w-full flex flex-col bg-white dark:bg-background">
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
}
